import React from 'react';

export function EditModal({ editingItem, setEditingItem, canEdit, handleEditSubmit }) {
  if (!editingItem) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}
    >
      <form
        onSubmit={handleEditSubmit}
        style={{
          background: '#fff',
          padding: 32,
          borderRadius: 8,
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          minWidth: 400
        }}
      >
        <h2>Modifier la commande</h2>
        <input
          name="order_number"
          defaultValue={editingItem.order_number}
          placeholder="Numéro de commande"
          required
        />
        <input
          name="city"
          defaultValue={editingItem.city}
          placeholder="Ville"
          required={editingItem.type !== 'departure'}
        />
        <input
          name="weight"
          type="number"
          step="0.01"
          min="0"
          defaultValue={editingItem.weight}
          placeholder="Poids (kg)"
          required
        />
        <input name="note" defaultValue={editingItem.note} placeholder="Note" />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
          <button type="button" onClick={() => setEditingItem(null)}>
            Annuler
          </button>
          <button type="submit" disabled={!canEdit}>
            Enregistrer
          </button>
        </div>
      </form>
    </div>
  );
}
